import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './index.scss';

const categoryClasses = classNames({
    [styles.productCategory]: true,
    'analytics-product-category': true,
});
const ProductCategory = ({ category }) => (
    <li className={categoryClasses} data-item-name={category.tag}>
        <a className={styles.productCategory__link} href={category.href}>
            {category.text}
        </a>
    </li>
);

ProductCategory.propTypes = {
    category: PropTypes.shape({
        text: PropTypes.string.text,
        href: PropTypes.string.text,
        tag: PropTypes.string.text,
    }).isRequired,
};

export default ProductCategory;
